import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const GTM_ID = 'GTM-PPQL6RZH';
declare global {
  interface Window {
    dataLayer?: any[];
  }
}
export function GoogleTagManager() {
  const location = useLocation();
  // Install GTM (head script + noscript iframe) once on mount
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (document.getElementById('gtm-script')) return;
    // Head script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');`;
    document.head.appendChild(script);
    // Noscript iframe (appended to body, immediately after opening tag would be ideal
    // but appending is the closest equivalent we can do from JS)
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  // Push a virtual pageview event on every client-side route change so GTM
  // tags (GA4, Ads, etc.) fire per page in this SPA.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search
    });
  }, [location.pathname, location.search]);
  return null;
}